export default __webpack_public_path__ + "assets/ico_failure-af822d27.svg";